import React from 'react';

import classNames from 'classnames';

import styles from './Radio.module.scss';

export interface RadioProps {
    /** Object with settings for input */
    input: {
        name?: string;
        id: string;
        value?: string;
    };
    isChecked?: boolean;
    withUXSelection?: boolean;
    isOnlyDeselectable?: boolean;
    customClass?: {
        Wrapper?: string;
        Label?: string;
        Input?: string;
    };
    hasError?: boolean;
    isDisabled?: boolean;
    onClick?: () => void;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const Radio: React.FC<React.PropsWithChildren<RadioProps>> = ({
    input,
    isChecked = false,
    hasError = false,
    isDisabled = false,
    withUXSelection = false,
    isOnlyDeselectable = false,
    children,
    customClass,
    onClick,
    onChange,
    ...rest
}) => {
    return (
        <div
            className={classNames(styles.Radio, customClass?.Wrapper, {
                [styles.Error]: hasError,
                [styles.WithUXSelection]: withUXSelection,
                [styles.OnlyDeselectable]: isOnlyDeselectable,
            })}
        >
            <input
                type="radio"
                name={input.name}
                id={input.id}
                value={input.value}
                disabled={isDisabled}
                onClick={onClick}
                onChange={onChange}
                checked={isChecked}
                {...rest}
            />
            <label className={customClass?.Label} htmlFor={input.id}>
                {children}
            </label>
        </div>
    );
};

export default Radio;
